import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../services/global-environment';
import { I18nService } from '../../../services/i18n.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'app-law-update-and-compare',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './law-update-and-compare.component.html',
  styleUrl: './law-update-and-compare.component.scss',
})
export class LawUpdateAndCompareComponent implements OnInit {
  @Input() selectedLaw: any = null;
  @Output() closePopup = new EventEmitter<void>();
  @Output() updateConfirmed = new EventEmitter<any>();

  // ViewChild 引用捲動容器
  @ViewChild('leftScrollContainer', { static: false }) leftScrollContainer!: ElementRef;
  @ViewChild('rightScrollContainer', { static: false }) rightScrollContainer!: ElementRef;

  private apiUrl = environment.apiUrl;

  // 新版本法規資料
  newVersionLaw: any = null;
  isLoadingNewVersion = false;
  loadError: string | null = null;
  // 同步捲動相關
  isSyncScrollEnabled = false;
  private isScrollingSynced = false; // 防止循環觸發捲動事件

  // 條次比對相關
  comparisonResults: Map<string, any> = new Map();
  isComparisonEnabled = false;

  // AI總結相關
  showAISummary = false;
  isLoadingAISummary = false;
  aiSummaryData: any = null;
  userComment = '';

  constructor(private http: HttpClient, private i18nService: I18nService) {}  ngOnInit() {
    if (this.selectedLaw) {
      console.log('選擇的法規:', this.selectedLaw);

      this.fetchNewVersionLaw();
    }
  }

  // 切換條次比對顯示模式
  toggleComparison() {
    this.isComparisonEnabled = !this.isComparisonEnabled;
    console.log('比對顯示模式已', this.isComparisonEnabled ? '啟用' : '關閉');
  }  // 執行條次比對
  performArticleComparison() {
    // 修正資料存取路徑

 console.log("開始比對");

    console.log("this.selectedLaw",this.selectedLaw);
        console.log("this.newVersionLaw",this.newVersionLaw);

    const oldArticles = this.selectedLaw?.law_articles;
    const newArticles = this.newVersionLaw?.law_articles;

    if (!oldArticles || !newArticles) {
      console.log('條次比對失敗：缺少必要資料');
      console.log('selectedLaw.law_articles:', oldArticles);
      console.log('newVersionLaw.laws.law_articles:', newArticles);
      return;
    }

    console.log('開始執行條次比對...');
    console.log('舊版本條次數量:', oldArticles.length);
    console.log('新版本條次數量:', newArticles.length);
    this.comparisonResults.clear();

    const filteredOldArticles = this.getFilteredArticles(oldArticles);
    const filteredNewArticles = this.getFilteredArticles(newArticles);

    // 建立舊版本條次對照表，方便快速查找
    const oldArticleMap = new Map();
    filteredOldArticles.forEach(article => {
      if (article.article_no) {
        oldArticleMap.set(article.article_no, article);
      }
    });

    // 建立新版本條次對照表，方便快速查找
    const newArticleMap = new Map();
    filteredNewArticles.forEach(article => {
      if (article.article_no) {
        newArticleMap.set(article.article_no, article);
      }
    });

    console.log('建立對照表完成');
    console.log('舊版本條次對照表大小:', oldArticleMap.size);
    console.log('新版本條次對照表大小:', newArticleMap.size);

    // 1. 遍歷右邊新版本的所有法條，找出新增和異動的條次
    filteredNewArticles.forEach(newArticle => {
      if (!newArticle.article_no) return;

      const oldArticle = oldArticleMap.get(newArticle.article_no);      if (!oldArticle) {
        // 新增的條次 - 檢查是否為內容相同但條次不同的情況
        const matchingOldArticle = this.findMatchingContentArticle(newArticle, filteredOldArticles);

        this.comparisonResults.set(`new_${newArticle.article_no}`, {
          type: 'added',
          article: newArticle,
          changes: this.generateAddedContent(newArticle.article_content || ''),
          originalArticleNo: matchingOldArticle?.article_no || null  // 記錄原條次號碼
        });

        if (matchingOldArticle) {
          console.log(`新增條次: ${newArticle.article_no} (原 ${matchingOldArticle.article_no} 條)`);
        } else {
          console.log(`新增條次: ${newArticle.article_no}`);
        }
      } else {// 檢查條次內容是否有變更
        const contentChanged = this.hasContentChanged(oldArticle, newArticle);        if (contentChanged) {
          // 為舊版本生成差異（顯示刪除和保持的內容）
          const oldChanges = this.generateTextDiff(oldArticle.article_content || '', newArticle.article_content || '');
          // 為新版本生成差異（顯示新增和保持的內容）
          const newChanges = this.generateTextDiff(oldArticle.article_content || '', newArticle.article_content || '');

          // 異動的條次 - 在舊版本側標記
          this.comparisonResults.set(`old_${oldArticle.article_no}`, {
            type: 'modified',
            article: oldArticle,
            changes: oldChanges,
            originalArticleNo: null  // 舊版本不需要顯示原條次資訊
          });

          // 異動的條次 - 在新版本側標記，檢查是否有內容相同的來源條次
          const matchingOldArticle = this.findMatchingContentArticle(newArticle, filteredOldArticles);
          this.comparisonResults.set(`new_${newArticle.article_no}`, {
            type: 'modified',
            article: newArticle,
            changes: newChanges,
            originalArticleNo: matchingOldArticle?.article_no || null
          });

          console.log(`異動條次: ${newArticle.article_no}${matchingOldArticle && matchingOldArticle.article_no !== newArticle.article_no ? ` (原 ${matchingOldArticle.article_no} 條)` : ''}`);
        }
      }
    });

    // 2. 遍歷左邊舊版本的所有法條，找出刪除的條次
    filteredOldArticles.forEach(oldArticle => {
      if (!oldArticle.article_no) return;

      const newArticle = newArticleMap.get(oldArticle.article_no);      if (!newArticle) {
        // 刪除的條次
        this.comparisonResults.set(`old_${oldArticle.article_no}`, {
          type: 'deleted',
          article: oldArticle,
          changes: this.generateDeletedContent(oldArticle.article_content || '')
        });
        console.log(`刪除條次: ${oldArticle.article_no}`);
      }
      // 注意：如果新版本中有對應條次，在上面的新版本遍歷中已經處理過了
    });

    console.log('條次比對結果:', this.comparisonResults);
    console.log('比對結果數量:', this.comparisonResults.size);
  }

  // 檢查條次內容是否變更
  private hasContentChanged(oldArticle: any, newArticle: any): boolean {
    const oldContent = (oldArticle.article_content || '').trim();
    const newContent = (newArticle.article_content || '').trim();
    return oldContent !== newContent;
  }
  // 生成文字差異標示 - 改進版本，同時處理新增、刪除和保持的文字
  private generateTextDiff(oldText: string, newText: string): { type: 'normal' | 'insertion' | 'deletion', text: string }[] {
    const result: { type: 'normal' | 'insertion' | 'deletion', text: string }[] = [];

    // 按句子或段落分割，提供更好的可讀性
    const oldSentences = this.splitTextIntoSegments(oldText);
    const newSentences = this.splitTextIntoSegments(newText);

    // 使用最長公共子序列算法找出差異
    const lcs = this.findLCS(oldSentences, newSentences);

    let oldIndex = 0;
    let newIndex = 0;
    let lcsIndex = 0;

    while (oldIndex < oldSentences.length || newIndex < newSentences.length) {
      if (lcsIndex < lcs.length &&
          oldIndex < oldSentences.length &&
          newIndex < newSentences.length &&
          oldSentences[oldIndex] === newSentences[newIndex] &&
          oldSentences[oldIndex] === lcs[lcsIndex]) {
        // 相同的文字片段
        result.push({ type: 'normal', text: oldSentences[oldIndex] });
        oldIndex++;
        newIndex++;
        lcsIndex++;
      } else if (oldIndex < oldSentences.length &&
                 (newIndex >= newSentences.length ||
                  (lcsIndex < lcs.length && oldSentences[oldIndex] !== lcs[lcsIndex]))) {
        // 刪除的文字片段
        result.push({ type: 'deletion', text: oldSentences[oldIndex] });
        oldIndex++;
      } else if (newIndex < newSentences.length) {
        // 新增的文字片段
        result.push({ type: 'insertion', text: newSentences[newIndex] });
        newIndex++;
      }
    }

    return result;
  }

  // 將文字分割成有意義的片段（句子、短語等）
  private splitTextIntoSegments(text: string): string[] {
    if (!text) return [];

    // 按標點符號和空格分割，保留分割符號
    const segments = text.split(/([。；，、：！？\s]+)/).filter(segment => segment.length > 0);
    return segments;
  }
  // 最長公共子序列算法 - 支援任何類型的陣列
  private findLCS<T>(arr1: T[], arr2: T[]): T[] {
    const m = arr1.length;
    const n = arr2.length;
    const dp: number[][] = Array(m + 1).fill(null).map(() => Array(n + 1).fill(0));

    // 建立 DP 表
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        if (arr1[i - 1] === arr2[j - 1]) {
          dp[i][j] = dp[i - 1][j - 1] + 1;
        } else {
          dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
        }
      }
    }

    // 回溯找出 LCS
    const result: T[] = [];
    let i = m, j = n;
    while (i > 0 && j > 0) {
      if (arr1[i - 1] === arr2[j - 1]) {
        result.unshift(arr1[i - 1]);
        i--;
        j--;
      } else if (dp[i - 1][j] > dp[i][j - 1]) {
        i--;
      } else {
        j--;
      }
    }

    return result;
  }
  // 取得條次比對結果
  getComparisonResult(article: any, isNewVersion: boolean = false): any {
    if (!this.isComparisonEnabled) return null;

    const key = `${isNewVersion ? 'new' : 'old'}_${article.article_no}`;
    return this.comparisonResults.get(key);
  }  // 取得條次狀態標籤
  getArticleStatusLabel(article: any, isNewVersion: boolean = false): string {
    const result = this.getComparisonResult(article, isNewVersion);
    if (!result) return '';

    // 左邊只顯示刪除標籤
    if (!isNewVersion) {
      return result.type === 'deleted' ? '刪除' : '';
    }

    // 右邊顯示新增和異動標籤
    switch (result.type) {
      case 'added':
        return '新增';
      case 'modified':
        return '異動';
      default:
        return '';
    }
  }

  // 取得條次狀態CSS類別
  getArticleStatusClass(article: any, isNewVersion: boolean = false): string {
    const result = this.getComparisonResult(article, isNewVersion);
    if (!result) return '';

    switch (result.type) {
      case 'added':
        return 'status-added';
      case 'deleted':
        return 'status-deleted';
      case 'modified':
        return 'status-modified';
      default:
        return '';
    }
  }

  // 過濾章節，只顯示實際法條
  getFilteredArticles(articles: any[]): any[] {
    if (!articles) return [];
    return articles.filter(article => article.article_type !== 'C');
  }

  // 取得實際法條數量（排除章節）
  getActualArticleCount(articles: any[]): number {
    if (!articles) return 0;
    return articles.filter(article => article.article_type !== 'C').length;
  }
  // 檢查是否為章節
  isChapter(article: any): boolean {
    return article.article_type === 'C';
  }

  // 切換同步捲動功能
  toggleSyncScroll() {
    this.isSyncScrollEnabled = !this.isSyncScrollEnabled;
    console.log('同步捲動已', this.isSyncScrollEnabled ? '啟用' : '停用');
  }
  // 左側捲動事件處理
  onLeftScroll(event: Event) {
    if (!this.isSyncScrollEnabled || this.isScrollingSynced) return;

    const leftElement = event.target as HTMLElement;
    const rightElement = this.rightScrollContainer?.nativeElement;

    if (rightElement && leftElement) {
      this.isScrollingSynced = true;

      // 計算捲動比例，處理除零情況
      const leftMaxScroll = leftElement.scrollHeight - leftElement.clientHeight;
      const rightMaxScroll = rightElement.scrollHeight - rightElement.clientHeight;

      if (leftMaxScroll > 0 && rightMaxScroll > 0) {
        const scrollRatio = leftElement.scrollTop / leftMaxScroll;
        rightElement.scrollTop = scrollRatio * rightMaxScroll;
      }

      // 使用 requestAnimationFrame 確保平滑重置
      requestAnimationFrame(() => {
        this.isScrollingSynced = false;
      });
    }
  }

  // 右側捲動事件處理
  onRightScroll(event: Event) {
    if (!this.isSyncScrollEnabled || this.isScrollingSynced) return;

    const rightElement = event.target as HTMLElement;
    const leftElement = this.leftScrollContainer?.nativeElement;

    if (leftElement && rightElement) {
      this.isScrollingSynced = true;

      // 計算捲動比例，處理除零情況
      const rightMaxScroll = rightElement.scrollHeight - rightElement.clientHeight;
      const leftMaxScroll = leftElement.scrollHeight - leftElement.clientHeight;

      if (rightMaxScroll > 0 && leftMaxScroll > 0) {
        const scrollRatio = rightElement.scrollTop / rightMaxScroll;
        leftElement.scrollTop = scrollRatio * leftMaxScroll;
      }

      // 使用 requestAnimationFrame 確保平滑重置
      requestAnimationFrame(() => {
        this.isScrollingSynced = false;
      });
    }
  }
  // 關閉彈出視窗
  onClose() {
    this.closePopup.emit();
  }

  // 確認更新法規
  confirmUpdate() {
    if (this.newVersionLaw) {
      // 發送更新後的法規資料
      this.updateConfirmed.emit(this.newVersionLaw);
    }
  }
  // 取得最新版本的法規內容
  fetchNewVersionLaw() {
    if (!this.selectedLaw?.law_url) {
      this.loadError = this.i18nService.translate('regulation.update.no_url');
      return;
    }

    this.isLoadingNewVersion = true;
    this.loadError = null;

    // 使用與 ScanLawContent 相同的 API 端點和參數
    const params = new URLSearchParams();
    params.set('lawurl', this.selectedLaw.law_url);
    params.set('skipdatabase', "true"); //略過從資料庫取值


    const url = `${this.apiUrl}/api/lawParser/fetchLaw?${params.toString()}`;

    this.http.get<any>(url).subscribe({
      next: (response) => {
        console.log('取得最新法規版本成功:', response);        if (response && response.laws) {
          this.newVersionLaw = response.laws;

          // 設定新法規的法規層級與舊法規一致
          if (this.selectedLaw?.law_hierarchy) {
            this.newVersionLaw.law_hierarchy = this.selectedLaw.law_hierarchy;
          }

          // 自動執行條次比對
          this.performArticleComparison();

          console.log('自動執行條次比對完成');
        } else {
          this.loadError = this.i18nService.translate(
            'regulation.update.no_data'
          );
        }

        this.isLoadingNewVersion = false;
      },
      error: (error) => {
        console.error('取得最新法規版本失敗:', error);
        this.loadError =
          this.i18nService.translate('regulation.update.error') +
          ': ' +
          (error.message || '網路錯誤');
        this.isLoadingNewVersion = false;
      },
    });
  }

  // 格式化日期顯示
  formatDate(dateString: string): string {
    if (!dateString) return '未知';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW');
    } catch {
      return dateString;
    }
  }

  // 生成新增條次的顯示內容（全部標記為新增）
  private generateAddedContent(content: string): { type: 'normal' | 'insertion' | 'deletion', text: string }[] {
    const segments = this.splitTextIntoSegments(content);
    return segments.map(segment => ({ type: 'insertion' as const, text: segment }));
  }

  // 生成刪除條次的顯示內容（全部標記為刪除）
  private generateDeletedContent(content: string): { type: 'normal' | 'insertion' | 'deletion', text: string }[] {
    const segments = this.splitTextIntoSegments(content);
    return segments.map(segment => ({ type: 'deletion' as const, text: segment }));
  }

  // 查找內容相同的法條（用於判斷是否為條次移動的情況）
  private findMatchingContentArticle(targetArticle: any, searchArticles: any[]): any | null {
    if (!targetArticle?.article_content) return null;

    const targetContent = this.normalizeContent(targetArticle.article_content);

    for (const article of searchArticles) {
      if (!article?.article_content || article.article_no === targetArticle.article_no) continue;

      const articleContent = this.normalizeContent(article.article_content);

      // 檢查內容是否完全相同或高度相似
      if (this.isContentSimilar(targetContent, articleContent)) {
        return article;
      }
    }

    return null;
  }

  // 標準化內容（移除空白、換行等，用於比較）
  private normalizeContent(content: string): string {
    return content
      .replace(/\s+/g, '') // 移除所有空白字元
      .replace(/[。；，、：！？]/g, '') // 移除標點符號
      .toLowerCase();
  }

  // 檢查兩個內容是否相似（可以調整相似度閾值）
  private isContentSimilar(content1: string, content2: string): boolean {
    // 完全相同
    if (content1 === content2) return true;

    // 計算相似度（簡單的長度和字元比較）
    const similarity = this.calculateSimilarity(content1, content2);
    return similarity > 0.9; // 90% 相似度閾值
  }

  // 計算兩個字串的相似度
  private calculateSimilarity(str1: string, str2: string): number {
    const len1 = str1.length;
    const len2 = str2.length;
    const maxLen = Math.max(len1, len2);

    if (maxLen === 0) return 1.0;

    const distance = this.levenshteinDistance(str1, str2);
    return 1 - (distance / maxLen);
  }

  // 計算編輯距離（Levenshtein Distance）
  private levenshteinDistance(str1: string, str2: string): number {
    const matrix = [];

    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }

    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }

    return matrix[str2.length][str1.length];
  }
  // 取得原條次資訊（如果有的話）
  getOriginalArticleInfo(article: any, isNewVersion: boolean = false): string | null {
    if (!isNewVersion) return null;

    const result = this.getComparisonResult(article, isNewVersion);

    // 如果比對結果中已有原條次資訊，直接返回
    if (result?.originalArticleNo) {
      return result.originalArticleNo;
    }

    // 如果沒有比對結果或沒有原條次資訊，進行內容匹配檢查
    if (!this.selectedLaw?.law_articles) return null;

    const oldArticles = this.getFilteredArticles(this.selectedLaw.law_articles);
    const matchingOldArticle = this.findMatchingContentArticle(article, oldArticles);

    return matchingOldArticle?.article_no || null;
  }

  // AI總結相關方法

  // 切換AI總結顯示
  toggleAISummary() {
    this.showAISummary = !this.showAISummary;

    if (this.showAISummary && !this.aiSummaryData) {
      this.generateAISummary();
    }
  }

  // 取得變更統計
  getChangeStatistics() {
    const stats = {
      added: [] as string[],
      modified: [] as string[],
      deleted: [] as string[]
    };

    this.comparisonResults.forEach((result, key) => {
      const articleNo = result.article.article_no;

      switch (result.type) {
        case 'added':
          stats.added.push(articleNo);
          break;
        case 'modified':
          // 只統計新版本的異動條次，避免重複
          if (key.startsWith('new_')) {
            stats.modified.push(articleNo);
          }
          break;
        case 'deleted':
          stats.deleted.push(articleNo);
          break;
      }
    });

    return stats;
  }

  // 生成AI總結
  generateAISummary() {
    if (!this.selectedLaw || !this.newVersionLaw) {
      console.error('缺少必要資料無法生成AI總結');
      return;
    }

    this.isLoadingAISummary = true;

    // 從環境變數取得公司ID
    const companyid = environment.companyid;
    if (!companyid) {
      console.error('缺少公司ID，無法呼叫AI API');
      this.isLoadingAISummary = false;
      this.setFallbackSummaryData();
      return;
    }

    // 準備API請求資料
    const requestData = {
      oldlaw: this.selectedLaw,
      newlaw: this.newVersionLaw,
      companyid: companyid,
      assistantNo: "1",
      model_version: "o4-mini",
      max_tokens: 32768
    };

    // 呼叫AI分析API
    const url = `${this.apiUrl}/api/law_check_list/get_ai_law_compare_summary`;

    console.log('呼叫AI法規比較摘要API:', url);
    console.log('請求資料:', {
      companyid: requestData.companyid,
      assistantNo: requestData.assistantNo,
      model_version: requestData.model_version,
      oldlaw_name: this.selectedLaw.law_name || this.selectedLaw.laws?.law_name,
      newlaw_name: this.newVersionLaw.law_name || this.newVersionLaw.laws?.law_name
    });

    this.http.post<any>(url, requestData).subscribe({
      next: (response) => {
        console.log('AI總結API回應:', response);

        if (response.success && response.data && response.data.summary) {
          // 解析AI回應的內容 - 處理API回應結構
          const summaryContent = response.data.summary.content || response.data.summary;

          this.aiSummaryData = {
            summary: this.formatAISummary(summaryContent),
            changeStats: this.getChangeStatistics(),
            impact: this.extractSectionFromSummary(summaryContent, '影響分析'),
            recommendations: this.extractSectionFromSummary(summaryContent, '建議行動'),
            metadata: {
              modelUsed: response.data.summary.model || 'Unknown',
              responseId: response.data.summary.response_id || 'Unknown',
              timestamp: new Date()
            }
          };

          console.log('AI總結資料已處理:', this.aiSummaryData);
        } else {
          console.warn('AI API 回應格式異常或缺少總結內容:', response);
          this.setFallbackSummaryData();
        }

        this.isLoadingAISummary = false;
      },
      error: (error) => {
        console.error('AI總結生成失敗:', error);

        // 提供更詳細的錯誤資訊
        let errorMessage = '未知錯誤';
        if (error.status) {
          errorMessage = `HTTP ${error.status}: ${error.statusText || '請求失敗'}`;
          if (error.error?.message) {
            errorMessage += ` - ${error.error.message}`;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        console.error('詳細錯誤資訊:', errorMessage);
        this.isLoadingAISummary = false;
        this.setFallbackSummaryData();
      }
    });
  }

  // 從AI總結中提取特定章節內容
  private extractSectionFromSummary(summary: string, sectionTitle: string): string {
    if (!summary) return '無相關資訊';

    // 尋找章節標題
    const patterns = [
      new RegExp(`\\*\\*${sectionTitle}[\\*]*[:：]([\\s\\S]*?)(?=\\*\\*|$)`, 'i'),
      new RegExp(`${sectionTitle}[:：]([\\s\\S]*?)(?=\\n\\n|\\*\\*|$)`, 'i'),
      new RegExp(`\\d+\\.\\s*\\*\\*${sectionTitle}[\\*]*[:：]([\\s\\S]*?)(?=\\d+\\.|\\*\\*|$)`, 'i')
    ];

    for (const pattern of patterns) {
      const match = summary.match(pattern);
      if (match && match[1]) {
        return match[1].trim();
      }
    }

    return '請參考完整AI總結內容';
  }

  // 設定預設的總結資料
  private setFallbackSummaryData() {
    const stats = this.getChangeStatistics();
    this.aiSummaryData = {
      summary: this.formatAISummary(`由於AI服務暫時無法使用，以下為基本統計資訊：

• 新增條次：${stats.added.length} 條
• 修改條次：${stats.modified.length} 條
• 刪除條次：${stats.deleted.length} 條

請手動檢視具體的法條變更內容以了解詳細影響。`),
      changeStats: stats,
      impact: '請手動檢視法條變更內容以了解對企業合規的影響。',
      recommendations: '建議詳細檢視每一個變更條次的具體內容，並評估對現有流程的影響。',
      metadata: {
        modelUsed: 'Fallback',
        responseId: 'N/A',
        timestamp: new Date()
      }
    };
  }

  // 格式化AI總結內容，將文字轉換為HTML格式
  formatAISummary(content: string): string {
    if (!content) return '暫無相關資訊';

    // 將換行符號轉換為 <br>
    let formatted = content.replace(/\n/g, '<br>');

    // 將 Markdown 樣式的粗體轉換為 HTML
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // 將項目符號轉換為更好的樣式
    formatted = formatted.replace(/^•\s/gm, '<span class="bullet-point">•</span> ');
    formatted = formatted.replace(/^-\s/gm, '<span class="bullet-point">•</span> ');

    // 處理編號列表
    formatted = formatted.replace(/^(\d+)\.\s/gm, '<span class="numbered-point">$1.</span> ');

    // 處理章節標題（數字加上雙星號）
    formatted = formatted.replace(/^(\d+)\.\s?\*\*(.*?)\*\*:/gm, '<h6 class="section-title"><span class="section-number">$1.</span> $2:</h6>');

    return formatted;
  }

  // 關閉AI總結
  closeAISummary() {
    this.showAISummary = false;
  }

  // 儲存使用者註解
  saveUserComment() {
    console.log('使用者註解已儲存:', this.userComment);
    // 這裡可以加入儲存到資料庫的邏輯
  }
}
